import React, {useEffect, useState} from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {Message} from 'primereact/message';
import {recruitmentApi} from '../recruitmentApi';
import {formatCrmDateTime} from '../../crm/crmFormatters';

export const importSummary = rows => rows.reduce((sum, row) => {
  if (row.status === 'failed') sum.failed++;
  else if (row.skipped) sum.skipped++;
  else if (row.candidate_id && ['new', 'existing'].includes(row.candidate_status)) sum[row.candidate_status]++;
  if (row.application_id) sum.applications++;
  return sum;
}, {new: 0, existing: 0, skipped: 0, failed: 0, applications: 0});

export const summaryText = (summary, t) => ['new', 'existing', 'skipped', 'failed', 'applications'].map(key => t(`recruitmentImport.totals.${key}`, {count: summary[key] || 0})).join(' · ');

export default function CandidateImportHistory({t, onOpen, canWrite}) {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState({first: 0, rows: 25});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true); setError('');
    recruitmentApi('get', '/candidate-import', undefined, {page: Math.floor(page.first / page.rows) + 1, item_per_page: page.rows})
      .then(response => { if (active) {setItems(response.data.data.items || []); setTotal(response.data.data.total_item_count || 0);} })
      .catch(e => {if (active) setError(e.response?.data?.message || e.message);})
      .finally(() => {if (active) setLoading(false);});
    return () => {active = false;};
  }, [page, refresh]);
  return <>
    {error && <Message severity="error" text={error}/>}
    <div className="p-text-right p-mb-2"><Button className="p-button-text" icon="pi pi-refresh" label={t('refresh')} onClick={() => setRefresh(value => value + 1)} disabled={loading}/></div>
    <DataTable value={items} dataKey="id" lazy paginator rows={page.rows} first={page.first} onPage={setPage} totalRecords={total} loading={loading}
      rowsPerPageOptions={[10, 25, 50, 100]} responsiveLayout="scroll" stripedRows emptyMessage={t('noResults')}>
      <Column field="filename" header={t('recruitmentImport.filename')}/>
      <Column header={t('columnCreatedAt')} body={row => formatCrmDateTime(row.created_at, t)}/>
      <Column field="uploaded_by" header={t('recruitmentImport.uploadedBy')}/>
      <Column header={t('status')} body={row => t(`recruitmentImport.state.${row.status}`)}/>
      <Column header={t('recruitmentImport.progress')} body={row => `${row.processed_rows} / ${row.total_rows}`}/>
      <Column header={t('recruitmentImport.result')} body={row => summaryText(row.summary, t)}/>
      <Column body={row => <Button className="p-button-sm p-button-outlined" icon={row.status === 'review' && canWrite ? 'pi pi-pencil' : 'pi pi-eye'}
        label={t(row.status === 'review' && canWrite ? 'recruitmentImport.continue' : 'recruitmentImport.details')} onClick={() => onOpen(row.id)}/>}/>
    </DataTable>
  </>;
}
